


















































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { UserService } from '@/services/UserService';
import { UserSearchModel, UserModel, StickySettingsActions, StickyStoreNames, StickySettingsGetters, StickySettingsFields } from '@/types';
import { RouteRegEx } from '@/types/enums';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import OrganisationSelectList from '@/components/configuration/OrganisationSelectList.vue';
import { ComponentHelper, MTablehelper, RouteHelpers } from '@/mixins';
import ApiConfiguration from '@/classes/ApiConfiguration';

export default Vue.extend({
  name: 'UserManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers],
  data() {
    return {
      isLoading: false,
      pageIsLoading: true,
      users: [] as UserModel[],
      userSearchModel: {} as UserSearchModel,
      showPasswordHashUpdateModal: false,
      countOfUsersWithLegacyPasswordTypes: 0,
      isUpdatingPasswordHashes: false,
      fields: [
        {
          username: {
            label: 'User Name',
            sortable: true
          }
        },
        {
          name: {
            label: 'Name',
            sortable: true
          }
        },
        {
          emailAddress: {
            label: 'Email Address',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    ...mapActions(StickyStoreNames.UserManagement, [StickySettingsActions.ResetStickyState, StickySettingsActions.SetStickyStateField]),
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        await UserService.checkMaintenancePermissions();
        this.resetFilters();
        await this.getUsersAsync();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    },
    async getUsersAsync(this: any) {
      try {
        this.isLoading = true;
        this.users = await UserService.getUsersAsync(this.userSearchModel);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async countUsersWithLegacyPasswordHashesAsync(this: any) {
      try {
        this.isLoading = true;
        this.countOfUsersWithLegacyPasswordTypes = await ApiConfiguration.api().users.usersCountUsersWithLegacyPasswordHashesList();
      } catch (error) {
        this.$log(error);
        this.countOfUsersWithLegacyPasswordTypes = 0;
      } finally {
        this.isLoading = false;
      }
    },
    resetFilters(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.User);
      if (!canKeepState) {
        this.resetStickyState();
        this.resetMTableState();
      }

      this.userSearchModel = {
        organisationId: this.getStickyStateField(StickySettingsFields.OrganisationId),
        isDeactivated: this.getStickyStateField(StickySettingsFields.ShowDeactivated) ? null : false
      };
    },
    navigateToId(this: any, routeName: any, data: any = null, paramName: string = 'id') {
      if (data) {
        const value = paramName === 'id' ? data : data.id;
        this.onTableStateFieldUpdated('selectedPk', value);
      }
      this.navigateToRoute(routeName, data, paramName);
    },
    async onUpdatePasswordTypes(this: any) {
      this.isUpdatingPasswordHashes = true;
      try {
        while (this.countOfUsersWithLegacyPasswordTypes > 0) {
          this.countOfUsersWithLegacyPasswordTypes = await ApiConfiguration.api().users.usersUpdateLegacyPasswordHashesCreate();
        }
        this.showPasswordHashUpdateModal = false;
      } catch (error) {
        this.$log(error);
      } finally {
        this.isUpdatingPasswordHashes = false;
      }
    }
  },
  computed: {
    ...mapGetters(StickyStoreNames.UserManagement, [StickySettingsGetters.GetStickyStateField]),
    ...mapGetters('userStore', ['isUserAdministrator']),
    userManagementStateField(this: any) {
      return (field: string) => this.getStickyStateField(field);
    },
    localshowDeactivated: {
      get(this: any): boolean {
        return this.userManagementStateField(StickySettingsFields.ShowDeactivated);
      },
      set(this: any, value: any) {
        this.setStickyStateField({ field: StickySettingsFields.ShowDeactivated, value });
        this.userSearchModel.isDeactivated = value ? null : false;
      }
    },
    localOrganisationId: {
      get(this: any): number {
        return this.userManagementStateField(StickySettingsFields.OrganisationId);
      },
      set(this: any, value: any) {
        this.setStickyStateField({ field: StickySettingsFields.OrganisationId, value });
        this.userSearchModel.organisationId = value;
      }
    },
    updatePasswordTypesButtonIsVisible(this: any): boolean {
      return this.isUserAdministrator && this.countOfUsersWithLegacyPasswordTypes > 0;
    },
    waitingTimeNoteForPasswordHashUpdates(this: any): string {
      if (this.countOfUsersWithLegacyPasswordTypes <= 0) {
        return '';
      }

      const totalSeconds = Math.ceil(this.countOfUsersWithLegacyPasswordTypes * 0.5);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      const timeDisplay = [minutes > 0 && `${minutes} minute${minutes !== 1 ? 's' : ''}`, seconds > 0 && `${seconds} second${seconds !== 1 ? 's' : ''}`].filter(Boolean).join(' ');

      return `Estimated waiting time: ${timeDisplay}. Don't refresh the page while the update in progress`;
    }
  },
  watch: {
    userSearchModel: {
      handler(this: any, val, oldVal) {
        this.getUsersAsync();
      },
      deep: true
    }
  },
  async mounted(this: any) {
    await this.initialise();
    await this.countUsersWithLegacyPasswordHashesAsync();
  },
  components: {
    MStoreTable,
    OrganisationSelectList,
    LoadingSpinner
  }
});
